import { createFileRoute, useParams } from '@tanstack/react-router'
import { WorkspaceShopifySettings } from '@/features/workspaces/settings'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/integrations'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId } = useParams({
    from: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/integrations',
  })

  return <WorkspaceShopifySettings workspaceId={workspaceId} />
}
